import { apiClient } from './client';
import type { ApiResponse, SavedSearch, CreateSavedSearchInput } from '@/types';

export async function getSavedSearches(): Promise<ApiResponse<SavedSearch[]>> {
  const response = await apiClient.get<ApiResponse<SavedSearch[]>>('/saved-searches');
  return response.data;
}

export async function getSavedSearch(id: string): Promise<ApiResponse<SavedSearch>> {
  const response = await apiClient.get<ApiResponse<SavedSearch>>(`/saved-searches/${id}`);
  return response.data;
}

export async function createSavedSearch(data: CreateSavedSearchInput): Promise<ApiResponse<SavedSearch>> {
  const response = await apiClient.post<ApiResponse<SavedSearch>>('/saved-searches', data);
  return response.data;
}

export async function updateSavedSearch(id: string, name: string): Promise<ApiResponse<SavedSearch>> {
  const response = await apiClient.patch<ApiResponse<SavedSearch>>(`/saved-searches/${id}`, { name });
  return response.data;
}

export async function toggleEmailNotifications(id: string, enabled: boolean): Promise<ApiResponse<SavedSearch>> {
  const response = await apiClient.patch<ApiResponse<SavedSearch>>(
    `/saved-searches/${id}/notifications`,
    { emailNotifications: enabled }
  );
  return response.data;
}

export async function deleteSavedSearch(id: string): Promise<ApiResponse<void>> {
  const response = await apiClient.delete<ApiResponse<void>>(`/saved-searches/${id}`);
  return response.data;
}
